import type { AnnotationMetadata } from '@st/document-viewer-kit/plugins/annotations'
import { StampAnnotation } from '@st/sdk'
import { formatFullNameInitials } from '@st/util/human-name'

export function formatSignOffAuthor(defaultText: string, authorName?: string) {
  return formatFullNameInitials(authorName ?? '') || defaultText
}

export function completeSignOffAnnotation(
  annotation: StampAnnotation,
  metadata: AnnotationMetadata
): StampAnnotation {
  const date = new Date(annotation.time).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit',
    timeZone: metadata.timeZone
  })
  return { ...annotation, text: `${annotation.text} - ${date}` }
}
